import React from 'react';
import Text from '../../../BaseModule/Components/Text';
import NoEscape from '../../../../Utils/NoEscape';

export interface UserProfileItem {
	title: string;
	value: string;
}

interface Props {
	item: UserProfileItem;
}

const FamilyMemberProfileItem: React.FC<Props> = ({ item }) => {
	return (
		<div className='user-profile-card__body__item'>
			<Text
				className='user-profile-card__body__item__label'
				tx={item.title}
				firstUpper
			/>
			<div className='user-profile-card__body__item__value'>
				<NoEscape>{item.value}</NoEscape>
			</div>
		</div>
	);
};

export default FamilyMemberProfileItem;
